import React from "react";
import Helmet from "react-helmet";
// import { Link, graphql } from "gatsby";
import Layout from "../../components/Layout";

const FAQPage = () => {
  return (
    <Layout>
      <Helmet title={`0Box`} />
      <div>Welcome to the FAQ page.</div>
    </Layout>
  );
};
export default FAQPage;
